import { useMemo, useState } from 'react';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { getEmailMetadata } from 'conversations-message-history/common-message-format/operators/getEmailMetadata';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getCallMetadataAttachment } from 'conversations-message-history/call/operators/callMetadataAttachmentGetters';
// @ts-expect-error module not typed
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import CommonMessageHeaderPopoverList from './CommonMessageHeaderPopoverList';
import { getEmailMessagePopoverContents } from './getEmailMessagePopoverContents';
import { getCallMessagePopoverContents } from './getCallMessagePopoverContents';
import { getCommonMessageHeaderContents } from './getCommonMessageHeaderContents';
import MessageActionsButton from '../common-message-actions/MessageActionsButton';
import { jsx as _jsx } from "react/jsx-runtime";
const CommonMessageHeaderPopover = ({
  message,
  sender,
  isSenderLoading,
  recipient,
  isRecipientLoading
}) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const handlePopoverToggle = () => {
    setPopoverOpen(!popoverOpen);
  };
  const options = useMemo(() => {
    if (isCommonMessageFormat(message) && Boolean(getEmailMetadata(message))) {
      return getEmailMessagePopoverContents({
        message
      });
    }
    const callMetadata = getCallMetadataAttachment(message);
    if (callMetadata) {
      return getCallMessagePopoverContents({
        message,
        sender,
        isSenderLoading,
        recipient,
        isRecipientLoading
      });
    }
    return getCommonMessageHeaderContents({
      message
    });
  }, [message, sender, isSenderLoading, recipient, isRecipientLoading]);
  if (options.length === 0) return null;
  return /*#__PURE__*/_jsx(UIPopover, {
    open: popoverOpen,
    closeOnOutsideClick: true,
    onOpenChange: handlePopoverToggle,
    content: /*#__PURE__*/_jsx(CommonMessageHeaderPopoverList, {
      options: options
    }),
    children: /*#__PURE__*/_jsx(MessageActionsButton, {
      buttonIcon: "downCarat",
      "data-test-id": "call-message-popover-button",
      onClick: handlePopoverToggle
    })
  });
};
CommonMessageHeaderPopover.displayName = 'CommonMessageHeaderPopover';
export default CommonMessageHeaderPopover;